<template>
  <div>
    <v-dialog v-model="directionDialog" width="700"
              @click:outside="closeDialog"
              @keydown.esc="closeDialog"
    >
      <v-card>
        <v-card-title>
          {{ direction != null && direction.departure != null ?  `${direction.departure.name}(${direction.departure.place})` : 'Depart'
          }} -
          {{ direction != null && direction.destination != null ?  `${direction.destination.name}(${direction.destination.place})` : 'Destination'
          }}
        </v-card-title>
        <v-card-text>

          <v-row>
            <v-col
              cols="12"
              md="6"
              sm="6"
              xs="6"
              class="marginCity"
            >
              <city-input
                v-model="direction.origin_place_id"
                :label="'Rechercher par la ville de départ'"
                :placeholder="'Rechercher par la ville de départ'"
                :rules="rules.departure_id"
              ></city-input>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="6"
              xs="6"
              class="marginCity"
            >
              <city-input
                v-model="direction.destination_place_id"
                :label="'Rechercher par la destination'"
                :placeholder="'Rechercher par la destination'"
                :rules="rules.destination_id"
              ></city-input>
            </v-col>
            <v-col cols="12" v-for="(price,index) in direction.prices" :key="index">
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="direction.prices[index].day_number"
                    readonly
                            :items="days"
                            item-value="id"
                            item-text="label"
                    hide-details
                            />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="direction.prices[index].min_price"
                    type="number"
                            label="Montant Minimum"
                    hide-details
                    step="500"
                    min="500"
                            />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="direction.prices[index].max_price"
                    type="number"
                            label="Montant Maximum"
                    hide-details
                    step="500"
                    min="500"
                            />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed small color="error" @click="closeDialog">{{ $t('Fermer') }}</v-btn>
          <v-spacer />
          <v-btn depressed small color="primary" @click="saveDirection" :loading="savingDirection">{{ $t('Enregistrer') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <custom-toolbar
      :title="$t('Directions')"
      :total="$store.getters['direction/total']"
      @refresh="getDirections"

    />
<!--    :add="'Nouveau direction'"
    @add="openItem"-->
    <v-card class="mb-2 mt-2">
      <v-alert
        v-model="isAlertVisible"
        :color="error ? 'error' : 'success'"
        dismissible
        text
        transition="slide-y-transition"
      >
        {{ message }}
      </v-alert>
      <v-card-title
        class="ml-4"
        style="padding-top: 2px; padding-bottom: 2px"
      >
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row class="marginHeader">
            <v-col
              cols="12"
              md="3"
              sm="3"
              xs="3"
              class="marginCity"
            >
              <city-input
                v-model="$store.state.direction.field.departure_id"
                :label="'Rechercher par la ville de départ'"
                :placeholder="'Rechercher par la ville de départ'"
                :rules="rules.departure_id"
                @change="filterItems"
                @getCity="getStartOmsId"
              ></city-input>
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="3"
              xs="3"
              class="marginCity"
            >
              <city-input
                v-model="$store.state.direction.field.destination_id"
                :label="'Rechercher par la destination'"
                :placeholder="'Rechercher par la destination'"
                :rules="rules.destination_id"
                @change="filterItems"
                @getCity="getEndOmsId"
              ></city-input>
            </v-col>

<!--            <v-col
              cols="12"
              md="3"
              sm="3"
              xs="3"
            >
              <v-select
                v-model="$store.state.direction.field.day_number"
                :items="days"
                item-text="label"
                item-value="id"
                label="Rechercher par jour"
                outlined
                dense
                placeholder="Rechercher par jour"
                clearable
                hide-details="auto"
                persistent-hint
                single-line
                @input="getDirections(1)"
              ></v-select>
            </v-col>-->
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card>
      <v-data-table
        :loading="isDialogVisible"
        loading-text="Chargement..."
        :headers="headers"
        :items="$store.getters['direction/directions']"
        :items-per-page="$store.getters['direction/per_page']"
        :page.sync="$store.getters['direction/current_page']"
        dense
        fixed-header
        height="500"
        hide-default-footer
        @page-count="currentPage = $event"
      >
        <template #[`item.departure.name`]="{item}">
          {{ item != null && item.departure != null ?  `${item.departure.name}(${item.departure.place})` : ''
          }}
        </template>
        <template #[`item.destination.name`]="{item}">
          {{ item != null && item.destination != null ?  `${item.destination.name}(${item.destination.place})` : ''
          }}
        </template>
        <template #[`item.user`]="{item}">
          {{ item.user !== null ? (item.user.name !== null ? item.user.name : item.user.phone_number) : null
          }}
        </template>
        <template #[`item.nb_passagers_left`]="{item}">
          <v-chip
            :color="item.nb_passagers_left > 0 ? 'success' : 'error'"
            small
          >
            {{ item.nb_passagers_left + '/' + item.nb_passagers }}
          </v-chip>
        </template>
        <template #[`item.normal_price`]="{item}">
          <div>{{ $t("Min") }}</div>
          <v-divider :height="0" />
          <div>{{ $t("Max") }}</div>

        </template>
        <template #[`item.monday`]="{item}">
          <div class="text-primary">{{ item.prices.find((e) => e.day_number == 0).min_price }}</div>
          <v-divider :height="0" />
          <div class="text--error">{{item.prices.find((e) => e.day_number == 0).max_price }}</div>
        </template>
        <template #[`item.tuesday`]="{item}">
          <div>{{ item.prices.find((e) => e.day_number == 1).min_price }}</div>
          <v-divider :height="0" />
          <div>{{item.prices.find((e) => e.day_number == 1).max_price }}</div>
        </template>
        <template #[`item.wednesday`]="{item}">
          <div>{{ item.prices.find((e) => e.day_number == 2).min_price }}</div>
          <v-divider :height="0" />
          <div>{{item.prices.find((e) => e.day_number == 2).max_price }}</div>
        </template>
        <template #[`item.thursday`]="{item}">
          <div>{{ item.prices.find((e) => e.day_number == 3).min_price }}</div>
          <v-divider :height="0" />
          <div>{{item.prices.find((e) => e.day_number == 3).max_price }}</div>
        </template>
        <template #[`item.friday`]="{item}">
          <div>{{ item.prices.find((e) => e.day_number == 4).min_price }}</div>
          <v-divider :height="0" />
          <div>{{item.prices.find((e) => e.day_number == 4).max_price }}</div>
        </template>
        <template #[`item.saturday`]="{item}">
          <div>{{ item.prices.find((e) => e.day_number == 5).min_price }}</div>
          <v-divider :height="0" />
          <div>{{item.prices.find((e) => e.day_number == 5).max_price }}</div>
        </template>
        <template #[`item.sunday`]="{item}">
          <div>{{ item.prices.find((e) => e.day_number == 6).min_price }}</div>
          <v-divider :height="0" />
          <div>{{item.prices.find((e) => e.day_number == 6).max_price }}</div>
        </template>
        <template #[`item.global_amount`]="{item}">
          <v-chip
            :color="new Date(item.start_date) > new Date() ? 'primary' : 'error'"
            small
          >
            {{ formatAmount(item.global_amount) }}
          </v-chip>
        </template>

        <template #[`item.start_date`]="{item}">
          {{ formattingDate(`${item.start_date}`) }}
        </template>
        <template #[`item.created_at`]="{item}">
          {{ formattingDate(`${item.created_at}`) }}
        </template>

        <template #[`item.cancelled_at`]="{item}">
          <v-chip
            v-show="item.cancelled_at !== null"
            color="error"
            small
          >
            <span
              class="font-weight-bold">{{ item.cancelled_at ? formattingDate(`${item.cancelled_at}`) : null
              }}</span>
          </v-chip>
        </template>

        <template #[`item.car`]="{item}">
          {{ item.car !== null ? `${item.car.marque} ${item.car.model} ${item.car.release_year}` : null
          }}
        </template>

        <!-- action -->
        <template #[`item.actions`]="{ item }">
          <buttons-group
            :item="item"
            :lock="false"
            :remove="true"
            :edit="true"
            :status="false"
            @view="openItem(item)"
            @edit="openItem(item)"
            @remove="deleteItemConfirm(item)"
          />
        </template>
      </v-data-table>

      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <v-text-field
              :value="$store.state.direction.field.paginate"
              label="Lignes par page:"
              type="number"
              min="-1"
              max="15"
              hide-details
              @input="getDirectionsPerPage"
            ></v-text-field>
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getDirections"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Voulez-vous bloquer cet utilisateur?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDelete"
          >
            Non
          </v-btn>
          <v-btn
            color="success"
            @click="deleteItemConfirm"
          >
            Oui
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiAccountLock,
  mdiLockOpen,
  mdiEyeOutline,
  mdiRefresh,
} from '@mdi/js'
import { mapGetters, mapState } from 'vuex'
import LoaderDialog from '@core/components/dialogs/LoaderDialog'
import {
  computed,
  getCurrentInstance,
  ref,
  onMounted,
} from '@vue/composition-api/dist/vue-composition-api'
import CityInput from '@core/components/autocomplete/CityInput'
import { formatDate, formatStartDate } from '@core/date/dateFunctions'
import { intToCurrency, notify } from '@core/dynamicComponents/dynamicComponents'
import { useRouter } from '@core/utils'
import CustomToolbar from '@core/components/toolbar/CustomToolbar'
import ButtonsGroup from '@core/components/buttons/ButtonsGroup'
import store from '@/store'
import { i18n } from '@/plugins/i18n'
import router from '@/router'

export default {
  name: 'Direction',
  components: {
    ButtonsGroup, CustomToolbar, CityInput, LoaderDialog,
  },
  props: {
    currentRoad: {
      type: Object,
      default: () => {
        return {
          id: null,
        }
      },
    },
  },
  setup(props, context) {
    const instance = getCurrentInstance()
    const isLockedColor = {
      false: 'info',
      true: 'success',
    }
    const roadId = ref(props.currentRoad.id)
    const date = ref(null)
    const directionDialog = ref(false)
    const menu = ref(false)
    const menu1 = ref(false)
    const picker = ref(null)
    const menuref = ref(null)
    const currentPage = ref(null)
    const lastPage = ref(null)
    const dialogDelete = ref(false)
    const isDialogVisible = ref(false)
    const savingDirection = ref(false)
    const message = ref(null)
    const error = ref(false)
    const isAlertVisible = ref(false)
    const direction = ref(
      {
        departure_id: null,
        destination_id: null,
        prices: [],
      })
    const rules = {
      max_amount: [true],
      min_amount: [true],
      nb_passagers: [true],
      start_date: [true],
      departure_id: [true],
      destination_id: [true],
      car: [true],
    }
    const { router } = useRouter()


    const save = d => {
      menuref.value.save(d)
    }

    const formattingDate = date => formatDate(date)

    const formattingStartDate = date => formatStartDate(date)

    const deleteItemConfirm = () => {
      closeDelete()
    }

    const openItem = item => {
      direction.value = item || {
        departure_id: null,
        destination_id: null,
        prices: [
          {
            day_number: 0, min_price: 500, max_price: 500, normal_price: 500,
          },
          {
            day_number: 1, min_price: 500, max_price: 500, normal_price: 500,
          },
          {
            day_number: 2, min_price: 500, max_price: 500, normal_price: 500,
          },
          {
            day_number: 3, min_price: 500, max_price: 500, normal_price: 500,
          },
          {
            day_number: 4, min_price: 500, max_price: 500, normal_price: 500,
          },
          {
            day_number: 5, min_price: 500, max_price: 500, normal_price: 500,
          },
          {
            day_number: 6, min_price: 500, max_price: 500, normal_price: 500,
          },
        ],
      }
      directionDialog.value = true
      //router.push({ name: 'showdirection', params: { id: item.id } })
    }

    const closeDelete = () => {
      dialogDelete.value = false
    }

    const closeDialog = () => {
      directionDialog.value = false
    }

    const getDirections = (page = 1) => {
      isDialogVisible.value = true
      store.dispatch('direction/getDirectionsList', {
        page,
        field: { ...store.state.direction.field, road_id: roadId.value },
      }).then(() => {
        currentPage.value = store.getters['direction/current_page']
        lastPage.value = store.getters['direction/last_page']
        isDialogVisible.value = false
        isAlertVisible.value = false

        /* Object.keys(this.rules).forEach(key => {
          this.rules[key] = [true]
        }) */
      }).catch(errorserver => {
        message.value = errorserver.response.data.message
        if (errorserver.response.data.errors !== undefined) {
          rules.max_amount = errorserver.response.data.errors.max_amount !== undefined ? errorserver.response.data.errors.max_amount : [true]
          rules.min_amount = errorserver.response.data.errors.min_amount !== undefined ? errorserver.response.data.errors.min_amount : [true]
          rules.nb_passagers = errorserver.response.data.errors.nb_passagers !== undefined ? errorserver.response.data.errors.nb_passagers : [true]
          rules.start_date = errorserver.response.data.errors.start_date !== undefined ? errorserver.response.data.errors.start_date : [true]
          rules.car = errorserver.response.data.errors.car !== undefined ? errorserver.response.data.errors.car : true
          rules.city = errorserver.response.data.errors.city !== undefined ? errorserver.response.data.errors.city : true
          rules.destination = errorserver.response.data.errors.destination !== undefined ? errorserver.response.data.errors.destination : [true]
        }
        error.value = true
        isAlertVisible.value = true
      })
    }

    const saveDirection = ()=> {

      console.log(direction.value)

      savingDirection.value = true
      store.dispatch('direction/updateDirection', direction.value).then((response) => {

        savingDirection.value = false
        directionDialog.value = false;
       // closeDialog()
        //direction.value = response.data
        //getDirections(1)
      }).catch(error => {

        savingDirection.value = false
        directionDialog.value = false;
      })
    }
    const getStartOmsId = event => {
      store.state.direction.field.departure_id = event ? event.toString() : null
      getDirectionsByFields()
    }

    const getEndOmsId = event => {
      store.state.direction.field.destination_id = event ? event.toString() : null
      getDirectionsByFields()
    }

    const getDirectionsByFields = () => {
      isDialogVisible.value = true
      store.dispatch('direction/getDirectionsList', {
        page: 1,
        field: store.state.direction.field,
      }).then(() => {
        currentPage.value = store.getters['direction/current_page']
        lastPage.value = store.getters['direction/last_page']
        isDialogVisible.value = false
        isAlertVisible.value = false
        error.value = false
        isAlertVisible.value = false

        /* Object.keys(this.rules).forEach(key => {
          this.rules[key] = [true]
        }) */
      }).catch(error => {
        message.value = error.response.data.message
        if (error.response.data.errors !== undefined) {
          rules.max_amount = error.response.data.errors.max_amount !== undefined ? error.response.data.errors.max_amount : [true]
          rules.min_amount = error.response.data.errors.min_amount !== undefined ? error.response.data.errors.min_amount : [true]
          rules.nb_passagers = error.response.data.errors.nb_passagers !== undefined ? error.response.data.errors.nb_passagers : [true]
          rules.start_date = error.response.data.errors.start_date !== undefined ? error.response.data.errors.start_date : [true]
          rules.created_at = error.response.data.errors.created_at !== undefined ? error.response.data.errors.created_at : [true]
          rules.car = error.response.data.errors.car !== undefined ? error.response.data.errors.car : [true]
          rules.departure_id = error.response.data.errors.departure_id !== undefined ? error.response.data.errors.departure_id : [true]
          rules.destination_id = error.response.data.errors.destination_id !== undefined ? error.response.data.errors.destination_id : [true]
        }
        error.value = true
        isAlertVisible.value = true
      })
    }

    const getDirectionsPerPage = per_page => {
      // eslint-disable-next-line camelcase
      if (per_page !== null) {
        isDialogVisible.value = true
        // eslint-disable-next-line camelcase
        store.state.direction.field.paginate = per_page

        // this.itemsPerPage = parseInt(per_page, 10)
        store.dispatch('direction/getDirectionsList', {
          page: currentPage.value,
          field: store.state.direction.field,
        }).then(() => {
          currentPage.value = store.getters['direction/current_page']
          lastPage.value = store.getters['direction/last_page']
          isDialogVisible.value = false
          isAlertVisible.value = false

          /* Object.keys(this.rules).forEach(key => {
            this.rules[key] = [true]
          }) */
        })
      }
    }

    const filterItems = () => {
      setTimeout(() => {
        getDirectionsByFields()
      }, 1500)
    }

    onMounted(() => {
      getDirections(store.getters['direction/current_page'])
    })

    const formatAmount = amount => intToCurrency(store.state.user.lang, {
      style: 'currency',
      currency: 'XAF',
      minimumFractionDigits: 0,
    }, amount)

    return {
      formatAmount,
      getDirectionsPerPage,
      filterItems,
      getDirectionsByFields,
      getStartOmsId,
      getEndOmsId,
      openItem,
      closeDelete,
      formattingDate,
      formattingStartDate,
      deleteItemConfirm,
      getDirections,
      closeDialog,
      saveDirection,
      savingDirection,
      directionDialog,
      direction,
      currentPage,
      lastPage,
      dialogDelete,
      isDialogVisible,
      message,
      isAlertVisible,
      error,
      rules,
      selectOptions: [
        { text: 'Oui', value: true },
        { text: 'Non', value: false },
        { text: 'Tous', value: null },
      ],
      save,
      date,
      menu,
      menu1,
      picker,
      menuref,
      headers: [
        { text: 'DEPART', value: 'departure.name' },
        { text: 'DESTINATION', value: 'destination.name' },
        { text: 'Prix', value: 'normal_price' },
        { text: 'Lundi', value: 'monday' },
        { text: 'Mardi', value: 'tuesday' },
        { text: 'Mercredi', value: 'wednesday' },
        { text: 'Jeudi', value: 'thursday' },
        { text: 'Vendredi', value: 'friday' },
        { text: 'Samedi', value: 'saturday' },
        { text: 'Dimanche', value: 'sunday' },
        /*  { text: 'DATE DE CREATION', value: 'created_at' },*/

        { text: 'ACTIONS', value: 'actions' },
      ],

      // itemsPerPage: parseInt(store.state.direction.field.paginate, 10),
      days: [
        { id: 0, label: 'Lundi' },
        { id: 1, label: 'Mardi' },
        { id: 2, label: 'Mercredi' },
        { id: 3, label: 'Jeudi' },
        { id: 4, label: 'Vendredi' },
        { id: 5, label: 'Samedi' },
        { id: 6, label: 'Dimanche' },
      ],
      is_locked: {
        1: true,
        2: false,
      },
      isLockedColor,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiAccountLock,
        mdiLockOpen,
        mdiEyeOutline,
        mdiRefresh,
      },
    }
  },
}
</script>

<style scoped>
@media only screen and (max-width: 1904px) {
  .marginHeader {
    margin: -26px;
  }
}

@media only screen and (max-width: 600px) {
  .marginHeader {
    margin: -13px;
  }
}

@media only screen and (max-width: 600px) {
  .marginCity {
    margin-bottom: -30px;
  }
}

</style>
